<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">



  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">
    <!-- <div style="justify-content: center;align-self: center;margin-top: 2%;"> -->
     
    <span  style="font-size: 25px;"> {{'Product Improvement Program Search' | translate | async}}</span>
    <span class="material-icons" style="margin-left: 90%; font-size: 27px; cursor: pointer;" (click)="NavigateToProductImprovementComponent()">articlearrow_right_althome</span>
    <!-- </div> -->
    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height: auto;">

      <!-- <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Select Built #" [(ngModel)]="Selectmodel" >
          <mat-option [value]="model.ID" *ngFor="let model of modelList" >{{model.modelName}}</mat-option>
        </mat-select>
      </mat-form-field> -->

      <!-- <mat-form-field  class="header-form-full-width">
        <input type="text"  placeholder="Select Build #"  (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto" >
        <mat-autocomplete (optionSelected)="onSelectBuildNO($event.option.value)"  [(ngModel)]="Selectmodel" #model_auto="ngModel"  #auto="matAutocomplete">
           <mat-option *ngFor="let model of modelList" [value]="model.modelName" >
            {{model.modelName}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field> -->

       
    
      <mat-form-field  class="header-form-full-width">
        <input type="text"  [(ngModel)]="InputSelectmodel"  placeholder="Select Build #"  (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto" ngDefaultControl>
        <mat-autocomplete (optionSelected)="onSelectBuildNO($event.option.value)"   [(ngModel)]="Selectmodel" #model_auto="ngModel"  #auto="matAutocomplete"   ngDefaultControl  >
           <mat-option *ngFor="let model of modelList" [value]="model.modelName" >
            {{model.modelName}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

     
    
    
    


      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Serial # Start' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="Enter Serial # Start" [(ngModel)]="serialStart">
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Serial # End' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="Enter Serial # End" [(ngModel)]="serialEnd">
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label> {{'PIP Number' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="PIP Number" [(ngModel)]="PIPNumber">
      </mat-form-field>



      <mat-form-field class="header-form-full-width">
        <mat-label> {{'Enter Heading' | translate | async}}</mat-label>
        <input type="text" matInput placeholder="Enter Heading" [(ngModel)]="PIPHeading">
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Select Status" [(ngModel)]="selectStatus">
          <mat-option [value]="status.Id" *ngFor="let status of PIPStatusList" >{{status.Status}}</mat-option>
        </mat-select>
      </mat-form-field>
 

    
      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate">
        <mat-placeholder> {{'Program Start Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate">
        <mat-placeholder> {{'Program End Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>



      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>
    


    

    </div>
    <div style="display: flex;flex-direction: row;">
      <button (click)="RestFields()"  class="button button--primary"><span class="button__text"
         >{{'Reset' | translate | async}}</span></button>
      <button (click)="searchPIPDetails()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
          >{{'Search' | translate | async}}</span></button>
    </div>
  </mat-card>


  <div style="width: 100%;">
    <div style="display: flex;min-width: 30%;height:40px; margin-top: 1%;">
      <span style="cursor: pointer;font-size: 17px;margin-left: 2%;"></span>

    </div>
  <div *ngIf="SearchResultsList.length>0" >   
    <!-- <table class="table table--full-width table--striped" style="margin-top: 9px; margin-left: 2%;">

      <tr>
        <th style="text-align: center;" >PIP# </th>
        <th style="text-align: center;" > Heading</th>
        <th style="text-align: center;" >Built # </th>
        <th style="text-align: center;" >SN# Start </th>
        <th style="text-align: center;" >SN# End </th>
      
        <th style="text-align: center;" >Start Date</th>
        <th style="text-align: center;" >End Date</th>
        <th style="text-align: center;" >Status</th>
        <th style="text-align: center;" >Support Pro.</th>
        <th></th>

      </tr>
      <ng-container *ngFor="let sr of SearchResultsList">
      <tr style="cursor: pointer;" >   
        <td (click)=" onClickOpenForm(sr)"  style="cursor: pointer; text-align: center;"  >{{sr.PIPNo}}</td>
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer; text-align: center;" >{{sr.PIPHeading}}</td>
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;text-align: center;" >{{sr.ModelNames}}</td>
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer; text-align: center;">{{sr.SerialStart}}</td>
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer; text-align: center;"  >{{sr.SerialEnd}}</td>
        
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer; text-align: center;" >{{sr.StartDate | date:'dd MMM yyyy'}}</td>
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer; text-align: center;" >{{sr.EndDate | date:'dd MMM yyyy'}}</td>
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer; text-align: center;">{{sr.PIPStatusName}}</td>
        <td (click)=" onClickOpenForm(sr)" style="cursor: pointer; text-align: center;" >{{sr.SupportProgramLevelName}}</td>
      

        
        <td>
          <i style="cursor: pointer;" *ngIf="sr.IsExpand"
              class="material-icons ttmodal__close-button"
              (click)="ChangeExpand(sr)" matTooltip="Show Less">expand_less</i>
          <i style="cursor: pointer;" *ngIf="!sr.IsExpand"
              class="material-icons ttmodal__close-button"
              (click)="ChangeExpand(sr)" matTooltip="Show More">expand_more</i>
      </td>
      </tr>
      <tr>
        <ng-container *ngIf="PIPImplementsList_.length>0">
        <td colspan=7 *ngIf="sr.IsExpand" style="overflow-y: scroll; overflow-x: clip;  margin-left: 5%; border: groove;">
          <table  class="table table--full-width table--striped" style="margin-left: 2%;" >
           <thead>
            <tr > 
                <th  style="padding: 16px 24px;width: 10%;"> Asset SN# </th>
                <th style="padding: 16px 24px;width: 10%;">Type</th>
                <th style="padding: 16px 24px;width: 10%;;"> Truck Model </th>
                <th style="padding: 16px 24px;width: 10%;;"> Unit# </th>
                <th style="padding: 16px 24px;width: 10%;;"> Customer</th>
                <th style="padding: 16px 24px;width: 10%;;">Jobsite </th>
                <th style="padding: 16px 24px;width: 10%;;"> Status </th>
                

            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let im of PIPImplementsList_">
            <tr *ngIf="sr.Id == im.PIPId" >
               <td> {{im.AssetSN}}</td>
               <td> {{im.Type}}</td>
               <td>{{im.TruckModelName}}</td>
               <td>{{im.UnitNo}}</td>
               <td> {{im.Customer}}</td>
               <td> {{im.JobSite}}</td>
               <td>  {{im.Status==1?'Active':'Expired'}}</td> 

            </tr>
          </ng-container>
          </tbody>
        </table>
      </td>
    </ng-container>
     </tr> 
     </ng-container>
   </table> -->


   <table id="table_detail" cellpadding=10 class="table table--full-width table--striped" style="margin-left: 2%;">

    <tr>
        <th>{{'PIP#' | translate | async}}</th>
        <th>{{'Heading' | translate | async}}</th>
        <th style="padding: 0px 24px;">{{'Built #' | translate | async}}</th>
        <th style="padding: 0px 24px;">{{'SN# Start' | translate | async}}</th>
        <th style="padding: 0px 24px;">{{'SN# End' | translate | async}}</th>
        <th style="padding: 0px 24px;">{{'Start Date' | translate | async}} </th>
        <th style="padding: 0px 24px;">{{'End Date' | translate | async}} </th>
        <th style="padding: 0px 24px;">{{'Status' | translate | async}}</th>
        <th style="padding: 0px 24px;">{{'Support Pro.' | translate | async}}</th>
        <th></th>

    </tr>
    <ng-container  *ngFor="let sr of SearchResultsList">
        <tr style="cursor: pointer;">

            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.PIPNo}}</td>
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;"> {{sr.PIPHeading}}</td>
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.ModelNames}}</td>
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.SerialStart}}</td>
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.SerialEnd}}</td>
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.StartDate | date:'dd MMM yyyy'}}</td> 
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.EndDate | date:'dd MMM yyyy'}}</td>
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.PIPStatusName}}</td>
            <td (click)=" onClickOpenForm(sr)" style="cursor: pointer;">{{sr.SupportProgramLevelName}}</td>

           


            <td>
                <i style="cursor: pointer;" *ngIf="sr.IsExpand" class="material-icons ttmodal__close-button"
                (click)="ChangeExpand(sr)" matTooltip="Show Less">expand_less</i>
                <i style="cursor: pointer;" *ngIf="!sr.IsExpand" class="material-icons ttmodal__close-button"
                (click)="ChangeExpand(sr)" matTooltip="Show More">expand_more</i>
            </td>


        </tr>
        <tr>
            <td colspan=9>
                <table class="table table--full-width table--striped" *ngIf="sr.IsExpand"
                    style="margin-left: 2%; border: groove;">
                    <thead>
                        <tr>
                            <th  style="padding: 0px 24px;width: 10%;">{{'Asset SN#' | translate | async}} </th>
                            <th style="padding: 0px 24px;width: 10%;">{{'Type' | translate | async}}</th>
                            <th style="padding: 0px 24px;width: 10%;">{{'Built #' | translate | async}} </th>            
                            <th style="padding: 16px 24px;width: 10%;;"> {{'Unit#' | translate | async}} </th>
                            <th style="padding: 16px 24px;width: 10%;;"> {{'Customer' | translate | async}}</th>
                            <th style="padding: 16px 24px;width: 10%;;"> {{'Jobsite' | translate | async}} </th>
                            <th style="padding: 16px 24px;width: 10%;;"> {{'Status' | translate | async}} </th> 
                            

                        </tr>
                    </thead>
                    <tbody>
                        <ng-container  *ngFor="let im of PIPImplementsList_">
                            <tr *ngIf="sr.Id == im.PIPId" (click)="OpenAssetscreen()" style="cursor: pointer;"> 
                                <td >{{im.AssetSN}}</td>
                                <td> {{im.Type}}</td>
                                <td class="SerialAndUnitText" title={{im.TruckModelName}} >{{im.TruckModelName}}</td>
                                <td>{{im.UnitNo}}</td>
                                <td> {{im.Customer}}</td>
                                <td> {{im.JobSite}}</td>
                                <td>  {{im.statusID==1?('Active' | translate | async):('Expired' | translate | async)}}</td> 
                                  

                            </tr>

                        </ng-container>
                    </tbody>

                </table>
            </td>

        </tr>
    </ng-container>

</table>







  </div>
    <div style="display: flex;flex-direction: column;align-items: center;
  justify-content: center;min-height: 500px;align-self: center;">
    </div>

  </div>



</div>